import { render } from "./Icon.vue?vue&type=template&id=c36946f8&scoped=true&ts=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import "./Icon.vue?vue&type=style&index=0&id=c36946f8&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36946f8"]])

export default __exports__